var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8531 6.53033C16.146 6.23744 16.146 5.76256 15.8531 5.46967L11.0801 0.696699C10.7872 0.403806 10.3123 0.403806 10.0195 0.696699C9.72656 0.989593 9.72656 1.46447 10.0195 1.75736L14.2621 6L10.0195 10.2426C9.72656 10.5355 9.72656 11.0104 10.0195 11.3033C10.3123 11.5962 10.7872 11.5962 11.0801 11.3033L15.8531 6.53033ZM0.322754 6.75H15.3228V5.25H0.322754V6.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArr);
export default __webpack_public_path__ + "static/media/arr.67480ee5f8a968beefcd6a09b463c2ee.svg";
export { ForwardRef as ReactComponent };